import DefaultLayout from "@/layouts/DefaultLayout";
import KSalesOrderErrorForm from "kinnect-front/Sales/SalesOrders/KSalesOrderErrorForm";
import { FetchesData, Pageable } from "kinnect-mixins";
import { OutboundFreight } from "kinnect-models";

export default {
	name: "OutboundFreightErrorPage",

	metaInfo: { title: "Warehouse - Outbound Freight - Add an Error" },

	props: {
		idOutboundFreight: {
			required: true,
			type: Number
		}
	},

	mixins: [
		FetchesData,
		Pageable
	],

	data: () => ( {
		outboundFreight: null
	} ),

	methods: {
		async fetchOutboundFreight() {
			this.outboundFreight = await OutboundFreight
			.include( "sales-orders" )
			.findPageModel( this.idOutboundFreight );
		},

		async fetch() {
			await this.fetchOutboundFreight();
		}
	},

	render() {
		if ( !this.fetched ) {
			return;
		}

		return <DefaultLayout maxWidth="800px">
			<KSalesOrderErrorForm
				formTitle="Add a Sales Order Error"
				salesOrdersTableProps={{
					items: this.outboundFreight.salesOrders,
					showSelect: true
				}}
			></KSalesOrderErrorForm>
		</DefaultLayout>;
	}
};
